import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Capacitor, CapacitorHttp } from '@capacitor/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface EmailData {
  name: string;
  email: string;
  subject: string;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  private readonly baseUrl: string = environment.server.mainURL;
  private endPointUrl: string = '';

  constructor(private client: HttpClient) { }

  async sendEmail(emailData: EmailData){
    this.endPointUrl = this.baseUrl + 'email/contact-email';
    if(Capacitor.isNativePlatform()){
      const res = await CapacitorHttp.post({ url: this.endPointUrl, data: {} });
      return res.data as boolean;
    }

    let params = new HttpParams();
    params = params.append('source', 'price-matcher');
    return lastValueFrom(this.client.post<boolean>(this.baseUrl + this.endPointUrl, emailData, {params: params}));
  }
}
